<app-select
  [options]="options()"
  [value]="value()"
  [placeholder]="placeholder()"
  [error]="error()"
  [loading]="loading()"
  [hasMore]="hasMore()"
  [searchable]="true"
  [remoteSearch]="true"
  (changed)="changed.emit($event)"
  (searchChange)="onSearch($event)"
  (loadMore)="onLoadMore()"
/>
